<template>
	<div
		class="alert"
		:class="{'can-close' : canClose}"
	>
		<component
			v-if="icon"
			:is="icon"
			class="alert-icon"
		/>
		<slot />
		<div
			v-if="canClose"
			class="close-alert"
			@click="startCloseAlert"
		>
			<button type="button" class="unbutton" @click="startCloseAlert">
				<svg-times/>
			</button>
		</div>
	</div>
</template>

<script>
import { mapMutations } from 'vuex'
import { alerts } from '../../mixins/alerts'
export default {
	mixins : [ alerts ],
	data () {
		return {
			closing : false
		}
	},
	props : {
		close : {
			type : Boolean,
			default () {
				return false
			}
		},
		closes : {
			type : [String, Boolean],
			default () {
				return false
			}
		},
		index : Number,
		icon  : String
	},
	computed : {
		canClose () {
			return this.close || this.closes;
		}
	},
	methods : {
		...mapMutations([ 'closeAlert' ]),
		startCloseAlert () {
			if (!this.closing) {
				// Check if we need to set a cookie so this alert won't open again.
				if (this.closes && true !== this.closes) {
					this.addClosedAlert(this.closes)
				}

				this.closing = true
				this.closeAlert(this.index)
			}

			setTimeout(() => {
				this.closing = false
			}, 0)
		}
	}
}
</script>
<style lange="scsss" scoped>
	.close-alert * {
		cursor: pointer;
	}
</style>
